import React from 'react'

const Star = ({ percentage = 100 }) => {
  const viewBoxWidth = 34
  const fillWidth = (percentage / 100) * viewBoxWidth

  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 34 34"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="starMask">
          <polygon
            points="27.865 31.83 17.615 26.209 7.462 32.009 9.553 20.362 0.99 12.335 12.532 10.758 17.394 0 22.436 10.672 34 12.047 25.574 20.22"
            fill="white"
            transform="translate(0,0)"
          />
        </mask>
      </defs>

      <rect width="34" height="34" fill="#4B5563" mask="url(#starMask)" />

      <rect
        width={fillWidth}
        height="34"
        fill="currentColor"
        mask="url(#starMask)"
      />
    </svg>
  )
}

export default Star
